import React from 'react';
import { css } from '@emotion/core';
import { getColorByState } from '../../../stores/dealMapperStore/dealMapUtil';

// TODO
const Cell = ({ cellObject, subCell, children, style }) => {
  const { borderColor, backgroundColor } = getColorByState(cellObject);
  return (
    <div
      css={css`
        cursor: pointer;
        min-height: 60px;
        h4 {
          margin: 5px;
        }
        margin: ${subCell ? '0 auto' : '4px 2px'};
        background: ${backgroundColor};
        border-radius: ${subCell ? '0px' : '0.6rem'};
        position: relative;
        overflow: hidden;

        border: ${subCell ? 'inherit' : '1px solid rgba(0, 0, 0, 0.23)'};
        border-top: 1px solid rgba(0, 0, 0, 0.23);
      `}
      style={{ ...style }}
    >
      {children}
    </div>
  );
};

export default Cell;
